import { render, staticRenderFns } from "./WinnerList.vue?vue&type=template&id=3e2928fa&scoped=true&"
import script from "./WinnerList.vue?vue&type=script&lang=js&"
export * from "./WinnerList.vue?vue&type=script&lang=js&"
import style0 from "./WinnerList.vue?vue&type=style&index=0&id=3e2928fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2928fa",
  null
  
)

export default component.exports